module.exports = __webpack_public_path__ + "media/images/advert-img-01-4442142ed7da92830c8c796fecfdc9ea.png";